import axios from 'axios'
import AWS from 'aws-sdk'
import apigClientFactory from 'aws-api-gateway-client'

export default class DataService {
  constructor (profile, tokens) {
    this.profile = profile
    this.tokens = tokens
    // Comment in for local backend testing
    // this.profile.api = "http://localhost:8092"
  }

  static buildQuery (queryParams) {
    return Object.keys(queryParams)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`)
      .join('&')
  }

  getApigClient () {
    if (this.apigClient) {
      return this.apigClient
    }

    const config = {
      invokeUrl: this.profile.api,
      accessKey: AWS.config.credentials.accessKeyId,
      secretKey: AWS.config.credentials.secretAccessKey,
      sessionToken: AWS.config.credentials.sessionToken,
      region: 'eu-central-1'
    }
    this.apigClient = apigClientFactory.newClient(config)

    return this.apigClient
  }

  getIsrsConfig() {
    return axios.get(`${this.profile.api}/isrs/v1/config`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  // => Customers
  getCustomers (page = 1, size = 10, sort = 'customerId') {
    page = page - 1
    const query = {
      page,
      size,
      sort
    }

    return axios.get(`${this.profile.api}/customers?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  searchCustomers (searchTerm, size = 10, page = 1, sort = 'customerId') {

    page = page - 1

    const query = {
      searchTerm,
      size,
      page
    }

    return axios.get(`${this.profile.api}/customers/search?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getCustomer (customerId) {
    return axios.get(`${this.profile.api}/customers/${customerId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  deleteCustomer (customerId) {
    return axios.delete(`${this.profile.api}/customers/${customerId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getCustomerEditPage (customerId) {
    return axios.get(`${this.profile.api}/customers/edit/${customerId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  createCustomer (payload) {
    return axios.post(`${this.profile.api}/customers`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  updateCustomer (customerId, payload) {
    return axios.put(`${this.profile.api}/customers/${customerId}`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getCustomerContacts (customerId) {
    return axios.get(`${this.profile.api}/customers/${customerId}/contacts`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  // getCustomerReturnShopPortal (customerId) {
  //   return axios.get(`${this.profile.customerService}/customers/${customerId}/returnshopportal`, {
  //     headers: {
  //       'x-token': this.tokens.accessToken
  //     }
  //   })
  // }

  createCustomerReturnShopPortal (customerId, payload) {
    return axios.post(`${this.profile.api}/customers/${customerId}/returnshopportal`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getReturnShopPortalByUUID (portalUuid) {
    const apigClient = this.getApigClient()
    const params = {
      portalUuid,
      customerService: this.profile.api
    }
    const pathTemplate = '/returnshopportals/uuid/{portalUuid}'
    const method = 'GET'
    const additionalParams = {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: {
        expand: true
      }
    }

    return apigClient.invokeApi(params, pathTemplate, method, additionalParams).then(result => {
      return result
    })
  }

  updateReturnShopPortal (returnShopPortalId, payload) {
    return axios.put(`${this.profile.api}/returnshopportals/${returnShopPortalId}`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  addParcelNumberContainer (payload) {
    return axios.post(`${this.profile.api}/isrs/v1/parcelnumbercontainers`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  createReturnPortalParcelNumberContainer (payload) {
    return axios.post(`${this.profile.api}/isrs/v1/returnportalparcelnumbercontainers`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  updateReturnPortalParcelNumberContainer (payload, returnportalparcelnumbercontainerId) {
    return axios.put(`${this.profile.api}/isrs/v1/returnportalparcelnumbercontainers/${returnportalparcelnumbercontainerId}`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getCustomerParcelNumberContainerByUuid (portalUuid) {
    return axios.get(`${this.profile.api}/isrs/v1/parcelnumbercontainers/customer/${portalUuid}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  validateReturnShopPortalByUUID (portalUuid) {
    return axios.head(`${this.profile.api}/returnshopportals/uuid/${portalUuid}`,  {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }


  addParcelNumberRange (payload) {
    return axios.post(`${this.profile.api}/isrs/v1/parcelnumberranges`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  // getCustomerReturnShopPortalCountries (customerId) {
  //   return axios.get(`${this.profile.customerService}/customers/${customerId}/returnshopportalcountries`, {
  //     headers: {
  //       'x-token': this.tokens.accessToken
  //     }
  //   })
  // }

  // => Contacts
  getContacts (page = 1, size = 10, sort = 'contactId') {
    page = page - 1
    const query = {
      page,
      size,
      sort
    }

    return this.getApigClient().invokeApi({}, '/contacts', 'GET', {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    }, {})
  }

  searchContacts (searchTerm, size = 10, page = 1, sort = 'id') {

    page = page - 1

    const query = {
      searchTerm,
      size,
      page,
      sort
    }

    return axios.get(`${this.profile.api}/contacts/search?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })

  }

  getContact (contactId) {
    return axios.get(`${this.profile.api}/contacts/${contactId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  createContact (payload) {
    return axios.post(`${this.profile.api}/contacts`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  deleteContact (contactId) {
    return axios.delete(`${this.profile.api}/contacts/${contactId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  updateContact(contactId, payload) {
    return axios.put(`${this.profile.api}/contacts/${contactId}`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getReturnShopPortals (page = 1, size = 10 , sort = 'uuid') {
    page = page - 1
    const query = {
      page,
      size,
      sort
    }

    return axios.get(`${this.profile.api}/returnshopportals?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  searchReturnShopPortals (searchTerm, size = 10, page = 1, sort = 'id') {

  page = page - 1

    const query = {
      searchTerm,
      page,
      size,
      sort
    }

    return axios.get(`${this.profile.api}/returnshopportals/search?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }


  getParcelNumberContainersConsumption (page = 1, size = 1) {
    page = page - 1
    const query = {
      page,
      size
    }

    return axios.get(`${this.profile.api}/isrs/v1/report/parcelnumbercontainers/consumption?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }


  getReturnsQuantity (page = 1, size = 1) {
    page = page - 1
    const query = {
      page,
      size
    }

    return axios.get(`${this.profile.api}/report/returns/quantity?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }




  getParcelNumberContainers (onlyActive = true ,page = 1, size = 10, sort = 'id') {
    page = page - 1
    const query = {
      onlyActive,
      page,
      size,
      sort
    }

    return axios.get(`${this.profile.api}/isrs/v1/parcelnumbercontainers?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  /**
   * Filter the parcel number containers based on the input
   *
   * @param {*} searchTerm Search input
   * @param {*} size page size
   * @param {*} page page number
   * @param {*} sort field to be sorted
   * @returns parcel number containers
   */

  searchParcelNumberContainers (searchTerm, size = 10, page = 1, sort = 'id') {

    page = page - 1

    const query = {
      searchTerm,
      size,
      page,
      sort
    }

    return axios.get(`${this.profile.api}/isrs/v1/parcelnumbercontainers/search?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })

  }

  // getParcelNumberRange by container id
  getParcelNumberRangesByContainerId (parcelNumberContainerId, page = 1, size = 10, sort = 'Id') {
    page = page - 1
    const query = {
      page,
      size,
      sort
    }
    return axios.get(`${this.profile.api}/isrs/v1/parcelnumbercontainers/${parcelNumberContainerId}/parcelnumberranges?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  // getReturnportalParcelnumberContainersByContainerId by container id
  getReturnportalParcelnumberContainersByContainerId (parcelNumberContainerId, page = 1, size = 10, sort = 'Id') {
    page = page - 1
    const query = {
      page,
      size,
      sort
    }

    return axios.get(`${this.profile.api}/isrs/v1/return-shop/parcel-number-container/${parcelNumberContainerId}?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  // get ParcelNumberContainer by id
  getParcelNumberContainer (id) {
    return axios.get(`${this.profile.api}/isrs/v1/parcelnumbercontainers/${id}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  updateParcelNumberContainer(id, payload) {
    return axios.put(`${this.profile.api}/isrs/v1/parcelnumbercontainers/id/${id}`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getCountryServiceProviders (page = 1, size = 20, sort = 'Id') {
    page = page - 1
    const query = {
      page,
      size,
      sort
    }

    return axios.get(`${this.profile.api}/countryserviceproviders?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  getCountryServiceProviderById (countryServiceProviderId) {
    return axios.get(`${this.profile.api}/countryserviceproviders/${countryServiceProviderId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getCountryServiceProviderMappings (page = 1, size = 10) {
    page = page - 1
    const query = {
      page,
      size
    }

    return axios.get(`${this.profile.api}/countryserviceprovidermapping?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  filterCountryServiceProviderMappings (fromCountryNumber, toCountryNumber) {
    const query = {}

    if (fromCountryNumber) {
      query['fromCountryNumber'] = fromCountryNumber
    }

    if (toCountryNumber) {
      query['toCountryNumber'] = toCountryNumber
    }

    return axios.get(`${this.profile.api}/countryserviceprovidermapping/filter?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  createCountryServiceProviderMapping (payload) {
    return axios.post(`${this.profile.api}/countryserviceprovidermapping`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  removeCountryServiceProviderMapping (countryServiceProviderMappingId) {
    return axios.delete(`${this.profile.api}/countryserviceprovidermapping/${countryServiceProviderMappingId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getReturns (page = 1, size = 5, sort = 'id') {
    page = page - 1

    const query = {page, size, sort}

    return axios.get(`${this.profile.api}/returns?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  getReturn (id) {
    return axios.get(`${this.profile.api}/returns/${id}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  searchReturns (searchTerm, size = 10, page = 1, sort = 'id') {

    page = page - 1

    const query = {
      searchTerm,
      size,
      page,
      sort
    }

    return axios.get(`${this.profile.api}/returns/search?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  // Config
  // getCountryServiceProviderConfig (countryServiceProviderId) {
  //   return axios.get(`${this.profile.returnShopPortalConfig}/countryserviceproviderconfig/${countryServiceProviderId}`)
  // }

  // saveCountryServiceProviderConfig (payload) {
  //   return axios.post(`${this.profile.returnShopPortalConfig}/countryserviceproviderconfig`, payload)
  // }

  saveReturnShopPortalConfig (id, payload) {
    return axios.put(`${this.profile.api}/isrs/v1/return-shop/${id}/config`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }


  setReturnShopCountryContactMappings(id, payload) {
    return axios.put(`${this.profile.api}/isrs/v1/return-shop/${id}/country-contact-mappings`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  setReturnShopParcelNumberContainer(id, parcelNumberContainerId) {
    return axios.put(`${this.profile.api}/isrs/v1/return-shop/${id}/parcel-number-container/${parcelNumberContainerId}`, undefined, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  setReturnShopPortalActive(id, isActive) {
    return axios.put(`${this.profile.api}/isrs/v1/return-shop/${id}/active/${isActive}`, undefined, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  renameReturnShopPortal(id, newName) {
    return axios.patch(`${this.profile.api}/isrs/v1/return-shop/${id}`, {
        "uuid": `${newName}`
      },
      {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  resolveAddress(address) {
    const query = {
      address,
      key: 'AIzaSyC5PX3kMNmlwwapkaJharbzY_rIthbdn7E'
    }

    return axios.get(`https://maps.googleapis.com/maps/api/geocode/json?${DataService.buildQuery(query)}`)
  }

  importCustomer(file, onUploadProgress = () => {}) {
    const data = new FormData()
    data.append('csvfile', file)

    const config = {
      onUploadProgress,
      headers: {
        'x-token': this.tokens.accessToken
      }
    }

    return axios.post(`${this.profile.api}/customers/upload`, data, config)
  }

  importContact(file, onUploadProgress = () => {}) {
    const data = new FormData()
    data.append('csvfile', file)

    const config = {
      onUploadProgress,
      headers: {
        'x-token': this.tokens.accessToken
      }
    }

    return axios.post(`${this.profile.api}/contacts/upload`, data, config)
  }

  getLocations(page = 1, page_size = 5) {
    page = page - 1

    const query = {page, page_size}

    return axios.get(`${this.profile.api}/isrs/v1/location?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  getOwner(ownerId) {
    return axios.get(`${this.profile.api}/isrs/v1/external-master-data/owner/id/${ownerId}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getOwners(page = 1, page_size = 5) {
    page = page - 1

    const query = {page, page_size}

    return axios.get(`${this.profile.api}/isrs/v1/owner?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  publishReturnShop(payload) {
    return axios.put(`${this.profile.api}/isrs/v1/return-shop`, payload, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  checkIdentifierAvailbility(identifier) {
    return axios.get(`${this.profile.api}/isrs/v1/return-shop/${identifier}/available`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }


  setParcelNumberContainersToReturnShop() {

  }

  getLocation(id) {
    return axios.get(`${this.profile.api}/isrs/v1/external-master-data/location/id/${id}`, {
      headers: {
        'x-token': this.tokens.accessToken
      }
    })
  }

  getLocationsBySearchTerm(searchTerm) {
    const query = {searchTerm}
    return axios.get(`${this.profile.api}/isrs/v1/external-master-data/search/location?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

  getOwnersBySearchTerm(searchTerm) {
    const query = {searchTerm}
    return axios.get(`${this.profile.api}/isrs/v1/external-master-data/search/owner?${DataService.buildQuery(query)}`, {
      headers: {
        'x-token': this.tokens.accessToken
      },
      queryParams: query
    })
  }

}



// WEBPACK FOOTER //
// ./client/services/data.js